import { useForm } from '@mantine/form';
import { useState } from 'react';
import {
	validateNumber,
	validateText,
} from '../../../util/validation/commonValidation';
import type { BarcodeDto } from '../types/BarcodeDto';

const defaultProduct: BarcodeDto = {
	barcode: '',
	description: '',
};

export function useUpsertBarcodeForm(product: BarcodeDto = defaultProduct) {
	const [inputs, setInputs] = useState<BarcodeDto>(product);

	const form = useForm<BarcodeDto>({
		mode: 'uncontrolled',
		initialValues: product,
		validate: {
			description: (value) => validateText(value, false, 'Description', 150),
			barcode: (value) => validateText(value, false, 'Barcode', 25),
			price: (v) =>
				validateNumber(v?.toString(), false, -1000000, 1000000, 'Price', false),
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}
